import HeaderCoverGray from "@/assets/graphics/backgrounds/header-cover-gray.png";
import HeaderCoverColorful from "@/assets/graphics/backgrounds/header-cover-colorful.png";
import { Theme } from "@/shared/constants";
import { twMerge } from "tailwind-merge";
import { EndemicImage } from "../Image";

interface Props {
  theme: Theme;
  className: string;
}

const DefaultCover = ({ className, theme }: Props) => {
  return (
    <EndemicImage
      alt="Endemic default cover image"
      src={theme === Theme.Endemic ? HeaderCoverGray : HeaderCoverColorful}
      className={twMerge(`object-cover`, className)}
      fill
    />
  );
};

export default DefaultCover;
